import React from 'react'
import { Button, Dimmer, Loader, Modal, Table } from 'semantic-ui-react'
import { RequestInstance } from '../../types/OrderStatus'
import { formatDateWithTZ } from '../../../utils/timezone'

interface Props {
    open: boolean
    onClose: () => void
    cancelRequest: () => void
    cancelAllOpenAndAcceptedOrders: () => void
    associatedOrders: RequestInstance[]
    facilityTimezone: string
    loading: boolean
}

const CloseAssociatedOrdersModal: React.FC<Props> = ({ open, onClose, cancelRequest, cancelAllOpenAndAcceptedOrders, associatedOrders, facilityTimezone, loading }) => {
    return (
        <Modal open={open} onClose={onClose} centered className="close-associated-orders-modal">
            <Dimmer active={loading}>
                <Loader active={loading} />
            </Dimmer>
            {/**Every associatedOrders order will have an OrderId and it will be same for all so we are taking associatedOrders[0] to display Order Id*/}
            <Modal.Header>The OrderId- <span className='statusHeading'>{associatedOrders && associatedOrders[0] && associatedOrders[0].OrderId && associatedOrders[0].OrderId}</span> is associated with the below orders, Do you want to close</Modal.Header>
            <div className="close-associated-orders-table-wrap">
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Order</Table.HeaderCell>
                            <Table.HeaderCell>OrderId</Table.HeaderCell>
                            <Table.HeaderCell>Scheduled Date</Table.HeaderCell>
                            <Table.HeaderCell>Assigned</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {associatedOrders && associatedOrders.length > 0 && associatedOrders.map((order) => (
                            <Table.Row key={order._id}>
                                <Table.Cell>{order.OrderName}</Table.Cell>
                                <Table.Cell>{order.OrderId}</Table.Cell>
                                <Table.Cell>{formatDateWithTZ(order.RequestedTime, 'MM/DD/YYYY hh:mm A', facilityTimezone)}</Table.Cell>
                                <Table.Cell>{order.AcceptedByName || "-"}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </div>
            <Modal.Actions>
                <Button onClick={cancelRequest} disabled={loading}>This Order</Button>
                <Button onClick={cancelAllOpenAndAcceptedOrders} disabled={loading}>All Orders</Button>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
            </Modal.Actions>
        </Modal>
    )
}

export default CloseAssociatedOrdersModal